import { api } from './index';

export type EmployeeStatus = 'ativo' | 'inativo' | 'ferias' | 'licenca';

export interface EmployeeUserAccess {
    id: number;
    role: 'ADMIN' | 'CLIENT' | 'USER';
    is_active: boolean;
    must_change_password?: boolean;
    password_changed_at?: string | null;
}

export interface Employee {
    id: number;
    user_id?: number | null;
    department_id?: number | null;
    name: string;
    email: string;
    cpf: string;
    cargo: string;
    setor: string;
    telefone: string;
    datadeadimissão: Date;
    status: EmployeeStatus;
    user?: EmployeeUserAccess | null;
}

export interface CreateEmployeeData {
    user_id?: number | null;
    department_id?: number | null;
    name: string;
    email: string;
    cpf: string;
    cargo: string;
    setor?: string;
    telefone: string;
    datadeadimissão: Date;
    status: EmployeeStatus;
}
export type UpdateEmployeeData = Partial<CreateEmployeeData>;

const baseUrl = '/employees';

type EmployeeApiResponse = Omit<Employee, 'datadeadimissão'> & {
    datadeadimissão: string | Date;
};

const parseEmployeeDate = (emp: EmployeeApiResponse): Employee => ({
    ...emp,
    datadeadimissão: new Date(emp.datadeadimissão),
});

export const employeeService = {
    async getAllEmployees(): Promise<Employee[]> {
            const response = await api.get(baseUrl);
        return response.data.map(parseEmployeeDate);
    },

    async getEmployeeById(id: number): Promise<Employee> {
            const response = await api.get(`${baseUrl}/${id}`);
        return parseEmployeeDate(response.data);
    },

    async createEmployee(data: CreateEmployeeData): Promise<Employee> {
            const response = await api.post(baseUrl, data);
        return parseEmployeeDate(response.data);
    },

    async updateEmployee(id: number, data: UpdateEmployeeData): Promise<Employee> {
            const response = await api.put(`${baseUrl}/${id}`, data);
        return parseEmployeeDate(response.data);
    },

    async deleteEmployee(id: number): Promise<Employee> {
            const response = await api.delete(`${baseUrl}/${id}`);
        return parseEmployeeDate(response.data);
    }
};
